export default __webpack_public_path__ + "static/media/water.f9024da5.jpg";